var projectTimeline = {
	"Project timeline": "项目时间线",
	"None planned": "无计划",
	"1-3 months": "1-3 个月",
	"4-6 months": "4-6 个月",
	"7-12 months": "7-12 个月",
	"More than 1 year": "1 年以上"
};

export { projectTimeline as default };
